import React, { memo } from 'react';
import { BaseEdge, EdgeLabelRenderer, getBezierPath } from '@xyflow/react';
import { RELATIONSHIP_CONFIG } from './erdConstants';

function RelationshipEdge({
  id, sourceX, sourceY, targetX, targetY,
  sourcePosition, targetPosition, data, selected,
}) {
  const relType = data?.relationshipType ?? 'reference';
  const cfg = RELATIONSHIP_CONFIG[relType] ?? RELATIONSHIP_CONFIG.reference;

  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX, sourceY, sourcePosition,
    targetX, targetY, targetPosition,
  });

  const isDashed = relType === 'reference' || relType === 'reads';

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        style={{
          stroke: selected ? '#f1f5f9' : cfg.color,
          strokeWidth: selected ? 2 : 1.5,
          strokeDasharray: isDashed ? '6 3' : undefined,
        }}
        markerEnd={`url(#arrow-${relType})`}
      />

      {(data?.label || selected) && (
        <EdgeLabelRenderer>
          <div
            style={{
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
              pointerEvents: 'all',
              position: 'absolute',
            }}
          >
            <div className="erd-edge-label-group">
              {data?.label && (
                <span className="erd-edge-label" style={{ backgroundColor: '#0f172a', color: cfg.color, border: `1px solid ${cfg.color}44` }}>
                  {data.label}
                </span>
              )}
              <span className="erd-edge-type" style={{ backgroundColor: '#0f172a', color: cfg.color }}>
                {cfg.label}
              </span>
            </div>
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
}

export default memo(RelationshipEdge);
